import { toast } from "react-toastify";
import { ToastCloseButton } from "./ToastCloseButton";
import { theme } from "@utilities";

interface ToastMessage {
    Message: string;
}

export const SuccessToast = ({ Message }: ToastMessage) => {
    toast.success(Message, {
        toastId: Message,
        className: "toastSuccess",
        closeButton: ToastCloseButton,
        icon: () => <img src="/images/toast/Tick.svg" />,
        progressStyle: { background: theme.colors.toast_success },
    });
};
